import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommEWalletIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M12.5161 1.42699C12.8326 1.15975 13.3058 1.19966 13.573 1.51613C16.3343 4.78605 17.75 8.37353 17.75 12C17.75 15.6265 16.3343 19.214 13.5731 22.4839C13.3059 22.8004 12.8327 22.8403 12.5162 22.573C12.1998 22.3058 12.1598 21.8326 12.4271 21.5161C14.9991 18.4703 16.25 15.2156 16.25 12C16.25 8.78439 14.999 5.52978 12.427 2.4839C12.1597 2.16743 12.1996 1.69423 12.5161 1.42699ZM9.51986 4.92385C9.83807 4.65868 10.311 4.70167 10.5762 5.01988C14.1341 9.28935 14.1533 14.9375 10.5617 18.997C10.2872 19.3072 9.81326 19.3362 9.50303 19.0617C9.19281 18.7873 9.16382 18.3133 9.43829 18.003C12.5134 14.5274 12.5326 9.71068 9.42383 5.98015C9.15866 5.66195 9.20165 5.18902 9.51986 4.92385ZM6.46967 7.71969C6.76256 7.42679 7.23744 7.42679 7.53033 7.71969C9.82322 10.0126 9.82322 13.9875 7.53033 16.2803C7.23744 16.5732 6.76256 16.5732 6.46967 16.2803C6.17678 15.9875 6.17678 15.5126 6.46967 15.2197C8.17678 13.5126 8.17678 10.4875 6.46967 8.78035C6.17678 8.48745 6.17678 8.01258 6.46967 7.71969Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
